import * as Factory from 'factory.ts'
import faker from 'faker'

import { type LegalEntitySummaryWithBaseCurrencyApiModel } from '../LegalEntitySummaryWithBaseCurrencyApiModel'

export const LegalEntitySummaryWithBaseCurrencyApiModelStub =
  Factory.Sync.makeFactory<LegalEntitySummaryWithBaseCurrencyApiModel>({
    id: Factory.each((i) => i + 1),
    uuid: Factory.each(() => faker.random.uuid()),
    name: Factory.each(() => faker.company.companyName()),
    base_currency: { id: 1, name: 'USD' },
  })
